import "./MentionsLegales.css";
 import { Helmet } from "react-helmet-async";
 const MentionsLegales = () => (
  <section className="legal-section">
        <Helmet>
      <title>Mentions légales | Ensemble pour la Forêt</title>
      <meta
        name="description"
        content="Mentions légales du site Ensemble pour la Forêt : éditeur, hébergeur, propriété intellectuelle et politique de confidentialité."
      />
    </Helmet>
    <div className="legal-inner">
      <h1 className="legal-title">Mentions légales</h1>
 
      <div className="legal-block">
        <h2 className="legal-h2">1. Éditeur</h2>
        <p className="legal-p">
          Le site ensemblepourlaforet.fr est édité par la SAS Climate Innov.
        </p>
        <ul className="legal-list">
          <li>SAS CLIMATE INNOV (France)</li>
          <li>7 rue René Vietto – 06200 NICE</li>
          <li>
            Mail :{" "}
            <a href="mailto:info@ensemblepourlaforet.fr" className="legal-link">
              info@ensemblepourlaforet.fr
            </a>
          </li>
          <li>N° SIREN : 930335195</li>
          <li>Code APE : 7112B</li>
          <li>Directeur de la publication : Pierre-Alain Revelat</li>
          <li>Coordination et mise à jour : Service communication de Climate Innov</li>
        </ul>
      </div>
 
      <div className="legal-block">
        <h2 className="legal-h2">2. Nom de domaine</h2>
        <p className="legal-p">
          Le nom de domaine ensemblepourlaforet.fr est enregistré auprès d'OVH :
        </p>
        <ul className="legal-list">
          <li>OVH SAS au capital de 10 069 020 €</li>
          <li>RCS Lille Métropole 424 761 419 00045</li>
          <li>Code APE 2620Z</li>
          <li>N° TVA : FR 22 424 761 419</li>
          <li>Siège social : 2 rue Kellermann – 59100 Roubaix – France</li>
        </ul>
      </div>
 
      <div className="legal-block">
        <h2 className="legal-h2">3. Hébergeur</h2>
        <p className="legal-p">
          L'infrastructure technique du site est déployée sur Amazon Web Services (AWS) :
        </p>
        <ul className="legal-list">
          <li>Amazon Web Services EMEA SARL</li>
          <li>Société à responsabilité limitée (SARL)</li>
          <li>Siège social : 38 Avenue John F. Kennedy, L-1855 Luxembourg</li>
          <li>Immatriculée au RCS de Luxembourg sous le n° B 186284</li>
          <li>N° TVA (établissement France) : FR 30 831 001 334</li>
        </ul>
      </div>
 
      <div className="legal-block">
        <h2 className="legal-h2">4. Conception et développement</h2>
        <p className="legal-p">
          Le site ensemblepourlaforet.fr a été conçu et réalisé par le service
          communication de Climate Innov en collaboration avec l'EDHEC Climate
          Institute.
        </p>
      </div>
 
      <div className="legal-block">
        <h2 className="legal-h2">5. Informatique et libertés</h2>
        <p className="legal-p">
          Ce site internet est conforme à la Dispense n° 7 – Délibération
          n°2006-138 du 9 mai 2006 de la commission nationale de l'informatique
          et des libertés, décidant de la dispense de déclaration des traitements
          constitués à des fins d'information ou de communication externe.
        </p>
        <p className="legal-p">
          Les informations recueillies font l'objet d'un traitement informatique
          destiné à l'acheminement éventuel de notre lettre d'information. En
          aucun cas, les données recueillies ne seront cédées ou vendues à des
          tiers.
        </p>
        <p className="legal-p">
          Conformément à la loi Informatique et Libertés du 6 janvier 1978
          modifiée, et au Règlement européen Général sur la Protection des
          Données 2016/679 (RGPD), vous bénéficiez d'un droit d'accès, de
          rectification, de suppression des données personnelles vous
          concernant. Pour cela, vous êtes libre, à tout moment, de vous
          désabonner de notre lettre d'information via le lien de désinscription
          présent dans chaque newsletter ou en adressant votre demande par
          e-mail à{" "}
          <a href="mailto:info@ensemblepourlaforet.fr" className="legal-link">
            info@ensemblepourlaforet.fr
          </a>
          . Votre requête sera traitée dans un délai maximum de 30 jours.
        </p>
      </div>
 
      <div className="legal-block">
        <h2 className="legal-h2">6. Copyright et propriété intellectuelle</h2>
        <p className="legal-p">
          Les contenus de ce site sont la co-propriété exclusive de la SAS
          Climate Innov et de l'EDHEC Climate Institute. Toute reproduction,
          distribution, modification, retransmission ou publication de ces
          éléments, partielles ou totales, est strictement interdite sans
          l'accord express écrit de la SAS Climate Innov.
        </p>
      </div>
 
      <div className="legal-block">
        <h2 className="legal-h2">7. Limitation de responsabilité</h2>
        <p className="legal-p">
          Les informations proposées par le présent site sont toujours soumises
          à un risque d'estimation avec des imprécisions liées aux conditions
          d'utilisation des modèles mis en œuvre et à la qualité des
          informations collectées. Ni l'EDHEC Climate Institute, ni Climate
          Innov ne sauraient être tenus responsables des conséquences morales,
          humaines et matérielles de l'utilisation de leurs services. En
          conséquence, l'utilisateur reconnaît utiliser ces informations sous sa
          responsabilité exclusive.
        </p>
      </div>
    </div>
  </section>
);
 
export default MentionsLegales;